<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="讲师等级">
        <Select v-model="searchCondition.level_id" clearable style="width:200px">
          <Option
            v-for="item in teacherLevels"
            :value="item.id"
            :key="item.id"
          >{{ item.level_name }}</Option>
        </Select>
      </Form-item>
      <Form-item label="讲师性别">
        <Select v-model="searchCondition.sex" clearable style="width:200px">
          <Option :value="0">男</Option>
          <Option :value="1">女</Option>
        </Select>
      </Form-item>
      <Form-item label="讲师名称">
        <Input
          style="width:200px"
          placeholder="请输入讲师名称关键字"
          v-model="searchCondition.teacher_name"
          clearable
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button type="primary" @click="createTeacher">新增约课讲师</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/oto/dispatch/index"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="none"
        keyField="id"
        method="get"
      >
        <template slot-scope="{ row }" slot="c1">
          <span>{{row.teacher_name}}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button
            type="text"
            size="small"
            :to="{name:'TeachOtoScheduleDetail',query:{id:row.teacher_id,name:row.teacher_name}}"
          >排课-</Button>
          <Button type="text" size="small" @click="deleteTeacher(row.teacher_id)">删除</Button>
        </template>
      </Grid>
    </div>
    <Modal v-model="showAddTeacher" title="约课讲师" width="600" scrollable>
      <Form ref="teacherForm" :rules="ruleValidate" :model="teacherInfo" :label-width="120">
        <FormItem label="选择讲师" prop="teacher_id">
          {{teacherInfo.teacher_name}}
          <Button type="default" icon="ios-add" @click="showSelectTeacher=true">选择讲师</Button>
        </FormItem>
        <FormItem label="选择等级" prop="level_id">
          <Select v-model="teacherInfo.level_id" style="width:200px">
            <Option
              v-for="item in teacherLevels"
              :value="item.id"
              :key="item.id"
            >{{ item.level_name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="讲师性别" prop="sex">
          <RadioGroup v-model="teacherInfo.sex">
            <Radio :label="0">
              <span>男</span>
            </Radio>
            <Radio :label="1">
              <span>女</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="讲师年龄" prop="age">
          <Input
            style="width:150px"
            type="number"
            v-model="teacherInfo.age"
            placeholder="请输入讲师年龄"
            :maxlength="50"
          />
        </FormItem>
        <FormItem label="讲师教龄" prop="teach_age">
          <Input
            style="width:150px"
            type="number"
            v-model="teacherInfo.teach_age"
            placeholder="请输入讲师教龄"
            :maxlength="50"
          />
        </FormItem>
        <FormItem :label="attr.attr" v-for="attr in attrs" :key="attr.id">
          <Select v-model="teacherInfo.attr[attr.id]" style="width:200px">
            <Option v-for="item in attr.value" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showAddTeacher=false">取消</Button>
        <Button type="primary" size="large" @click="submitForm('teacherForm')">确定</Button>
      </div>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectTeacher"
      title="选择讲师"
      @on-ok="confirmSelectTeacher"
      width="800"
    >
      <TeacherSelect ref="teacher" selectType="single" :type="1"></TeacherSelect>
    </Modal>
  </div>
</template>
<script>
import TeacherSelect from "@/components/GridSelect/TeacherSelect.vue";

export default {
  name: "TeachOtoSchedule",
  components: {
    TeacherSelect
  },
  data() {
    return {
      teacherLevels: [],
      showSelectTeacher: false,
      showAddTeacher: false,
      columns: [
        {
          title: "讲师名称",
          slot: "c1",
          key: "teacher_name",
          minWidth: 200
        },
        {
          title: "讲师等级",
          key: "level_name",
          width: 120
        },
        {
          title: "讲师性别",
          key: "sex_name",
          width: 100,
          align: "center"
        },
        {
          title: "讲师教龄",
          key: "teach_age",
          width: 100,
          align: "center"
        },
        {
          title: "两周内排课（节）",
          key: "dispatch_num",
          width: 140,
          align: "center"
        },
        {
          title: "两周内约课（节）",
          key: "invite_num",
          width: 140,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          width: 200,
          align: "center",
          fixed: "right"
        }
      ],
      searchCondition: {
        level_id: "",
        sex: "",
        teacher_name: ""
      },
      selectList: [],
      teacherInfo: {
        teacher_name: "",
        teacher_id: "",
        level_id: "",
        sex: "",
        age: "",
        teach_age: "",
        attr: {}
      },
      ruleValidate: {
        teacher_id: [
          {
            required: true,
            type: "number",
            message: "讲师不能为空",
            trigger: "change"
          }
        ],
        level_id: [
          {
            required: true,
            type: "number",
            message: "讲师等级不能为空",
            trigger: "change"
          }
        ],
        sex: [
          {
            required: true,
            type: "number",
            message: "讲师性别不能为空",
            trigger: "change"
          }
        ],
        age: [
          {
            required: true,
            message: "讲师年龄不能为空",
            trigger: "change"
          }
        ],
        teach_age: [
          {
            required: true,
            message: "讲师教龄不能为空",
            trigger: "change"
          }
        ]
      },
      attrs: []
    };
  },
  async created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.teacherLevels = await this.$http.get("/api/oto/teacher/index");
      // let attrs = await this.$http.get("/api/module/attribute/4");
      // attrs.forEach(a => {
      //   this.$set(this.teacherInfo.attr, a.id, "");
      // });
      // this.attrs = attrs;
    },
    rowsFormatter(rows) {
      rows.forEach(row => {
        row.sex_name = row.sex == 0 ? "男" : "女";
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.level_id = "";
        this.searchCondition.sex = "";
        this.searchCondition.teacher_name = "";
      }
      this.$refs.grid.searchRefresh();
      this.selectList = [];
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    async deleteTeacher(id) {
      await this.$promiseConfirm("确定要删除该讲师吗？");
      await this.$http.delete("/api/oto/dispatch/delete/" + id);
      this.$refs.grid.refresh();
    },
    createTeacher() {
      this.showAddTeacher = true;
      this.teacherInfo.teacher_id = "";
      this.teacherInfo.teacher_name = "";
      this.teacherInfo.level_id = "";
      this.teacherInfo.sex = "";
      this.teacherInfo.age = "";
      this.teacherInfo.teach_age = "";
      this.$refs.teacher.recoverSelectedItems([]);
      this.$refs.teacher.refresh();
      this.$refs.teacherForm.resetFields();
    },
    confirmSelectTeacher() {
      let list = this.$refs.teacher.getSelectList();
      if (list.length == 0) {
        this.teacherInfo.teacher_id = "";
        this.teacherInfo.teacher_name = "";
      } else {
        this.teacherInfo.teacher_id = list[0].id;
        this.teacherInfo.teacher_name = list[0].real_name;
      }
    },
    submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = {};
        data.teacher_id = this.teacherInfo.teacher_id;
        data.level_id = this.teacherInfo.level_id;
        data.sex = this.teacherInfo.sex;
        data.age = this.teacherInfo.age;
        data.teach_age = this.teacherInfo.teach_age;
        let teacher_attr = [];
        let attrValue = this.teacherInfo.attr;
        for (let key in attrValue) {
          teacher_attr.push({
            attr_id: key,
            attr_val_id: attrValue[key]
          });
        }
        data.teacher_attr = JSON.stringify(teacher_attr);
        await this.$http.post("/api/oto/teacher/creates", data);
        this.$refs.grid.refresh();
        this.showAddTeacher = false;
        this.getList();
      });
    }
  }
};
</script>